"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setOwnerFromLocation = exports.setStorefrontFromLocation = exports.clearClassesByMatcher = exports.setStyleClassWithPrefix = exports.getOwnerFromStorefront = exports.storefrontIsStore = exports.queryParameterToStorefront = exports.hostnameToStorefront = void 0;
var common_1 = require("../common");
// logic mirrored in app/code/local/GlamCorner/Utils/Helper/Data.php hostToStorefront()
function hostnameToStorefront(hostname) {
    if (hostname === void 0) { hostname = null; }
    hostname = hostname || window.location.hostname;
    if (hostname.includes("herwardrobe.com.au")) {
        return "herwardrobe";
    }
    var storefront = hostname.replace(/(\.(website|checkout))?(\.(staging|local))?\.glamcorner\.com\.au$/, "");
    if (storefront === "staging" || storefront === "website" || storefront === "glamcorner.com.au") {
        return "www"; // transitional
    }
    return storefront;
}
exports.hostnameToStorefront = hostnameToStorefront;
function queryParameterToStorefront(queryParameterString) {
    if (queryParameterString === void 0) { queryParameterString = undefined; }
    var storefront = common_1.parseQueryString(queryParameterString || window.location.search)["storefront"];
    if (Array.isArray(storefront)) {
        return storefront[0];
    }
    return storefront;
}
exports.queryParameterToStorefront = queryParameterToStorefront;
function storefrontIsStore(hostname) {
    if (hostname === void 0) { hostname = null; }
    var storefront = hostnameToStorefront(hostname);
    return storefront.indexOf("store") !== -1;
}
exports.storefrontIsStore = storefrontIsStore;
function getOwnerFromStorefront(storefront) {
    return storefront.split("-")[0];
}
exports.getOwnerFromStorefront = getOwnerFromStorefront;
function setStyleClassWithPrefix(prefix, className, body) {
    var matcher = new RegExp("^" + prefix);
    clearClassesByMatcher(body, matcher);
    body.classList.add("" + prefix + className);
}
exports.setStyleClassWithPrefix = setStyleClassWithPrefix;
function clearClassesByMatcher(body, matcher) {
    var classes = [].slice.call(body.classList);
    var storefrontClasses = classes.filter(function (name) { return name.match(matcher); });
    // IE11 support. Spread separator is not working well with polyfill
    storefrontClasses.forEach(function (c) { return body.classList.remove(c); });
}
exports.clearClassesByMatcher = clearClassesByMatcher;
function setStorefrontFromLocation(location, body) {
    if (location === void 0) { location = null; }
    if (body === void 0) { body = null; }
    location = location || window.location;
    body = body || window.document.body;
    var hostname = location.hostname;
    var storefront = hostnameToStorefront(hostname);
    setStyleClassWithPrefix("storefront-", storefront, body);
}
exports.setStorefrontFromLocation = setStorefrontFromLocation;
function setOwnerFromLocation(location, body) {
    if (location === void 0) { location = null; }
    if (body === void 0) { body = null; }
    location = location || window.location;
    body = body || window.document.body;
    var hostname = location.hostname;
    var storefront = hostnameToStorefront(hostname);
    var owner = getOwnerFromStorefront(storefront);
    setStyleClassWithPrefix("owner-", owner, body);
}
exports.setOwnerFromLocation = setOwnerFromLocation;
